import { Modal } from '@trackman/web-shared-components';
import Paragraph from 'components/TextComps/Paragraph';
import { ReactComponent as TrashIcon } from 'images/icons/Trash.svg';
import { observer } from 'mobx-react-lite';
import { useStores } from 'index';
import { useTranslation } from 'react-i18next';
import { useOrganizationStore } from 'stores/Organization/OrganizationStore';

type Props = {
  isModalOn: boolean;
  setIsModalOn: (isModalOn: boolean) => void;
  selected: string[];
};

export const DeleteStudentsModal = observer(({ isModalOn, setIsModalOn, selected }: Props) => {
  const { t } = useTranslation();
  const ss = useStores().studentsStore;
  const selectedOrganizationId = useOrganizationStore((state) => state.selectedOrganizationId);

  return (
    <Modal
      open={isModalOn}
      onClose={() => setIsModalOn(false)}
      aria-labelledby={t('DeleteStudents', { ns: 'studentsPage' })}
      aria-describedby={t('DeleteStudentsFromTheList', { ns: 'studentsPage' })}
      className='organization-modal'
      title={t('DeleteStudents', { ns: 'studentsPage' })}
      titleIcon={<TrashIcon />}
      cancelBtn={{
        label: t('Cancel', { ns: 'general' }),
        onClick: () => setIsModalOn(false),
        className: 'styled-button secondary',
      }}
      confirmBtn={{
        label: t('Delete', { ns: 'studentsPage' }),
        onClick: () => {
          ss.removeStudents(selected, selectedOrganizationId);
          setIsModalOn(false);
        },
      }}
    >
      <div className='modal-body'>
        <Paragraph>
          <>{t('AreYouSureYouWantToDeleteStudents', { ns: 'studentsPage' })}</>
        </Paragraph>
      </div>
    </Modal>
  );
});

export default DeleteStudentsModal;
